module.exports = "pegasus_template/assets/themecapture1/large/2.png";